import * as React from 'react'

import { Badge, Text } from '@enechain/ecloud-designsystem'
import { ToggleLabel } from '@enechain/eposition-proto/bfftypes/v1/label_pb'

type Props = {
  value: ToggleLabel
}

const toggleLabelBadge: React.FC<Props> = ({ value }) => {
  return (
    <Badge status={value.status ? 'positive' : 'negative'}>
      <Text textStyle="textMd">{value.label}</Text>
    </Badge>
  )
}

export const ToggleLabelBadge = React.memo(toggleLabelBadge)
